import "./fillins.js";

import IrealViewer from "./components/IrealViewer.vue";
import IrealDetail from "./components/IrealDetail.vue";
import TextComponent from "./components/TextComponent.vue";
import TextInputComponent from "./components/TextInputComponent.vue";
import DivComponent from "./components/DivComponent.vue";
import HistogramComponent from "./components/HistogramComponent.vue";
import ButtonComponent from "./components/ButtonComponent.vue";
import VideoComponent from "./components/VideoComponent.vue";
import ToggleButtonComponent from "./components/ToggleButtonComponent.vue";
import ProgressComponent from "./components/ProgressComponent.vue";
import RadioButtonComponent from "./components/RadioButtonComponent.vue";
import SliderInputComponent from "./components/SliderInputComponent.vue";
import MessageComponent from "./components/MessageComponent.vue";
import SpinnerButtonComponent from "./components/SpinnerButtonComponent.vue";
import ModalComponent from "./components/ModalComponent.vue";
import MapInputComponent from "./components/MapInputComponent.vue";
import TableInputComponent from "./components/TableInputComponent.vue";
import TableComponent from "./components/TableComponent.vue";
import CollapsibleComponent from "./components/CollapsibleComponent.vue";
import GaugeInputComponent from "./components/GaugeInputComponent.vue";
import GaugeComponent from "./components/GaugeComponent.vue";
import ThreeComponent from "./components/ThreeComponent.vue";
import InstitutionComponent from "./components/InstitutionComponent.vue";
import MapHelpHoverComponent from "./components/MapHelpHoverComponent.vue";
import SwitchButtonComponent from "./components/SwitchButtonComponent.vue";
// import AirspeedComponent from "./components/flight/AirspeedComponent.vue";
// import AltComponent from "./components/flight/AltComponent.vue";
// import AttitudeComponent from "./components/flight/AttitudeComponent.vue";
// import HeadingComponent from "./components/flight/HeadingComponent.vue";
// import TurnCoordinatorComponent from "./components/flight/TurnCoordinatorComponent.vue";
// import VariometerComponent from "./components/flight/VariometerComponent.vue";
import LinearInputComponent from "./components/LinearInputComponent.vue";
import SelectOutputComponent from "./components/SelectOutputComponent.vue";
import CheckboxInputComponent from "./components/CheckboxInputComponent.vue";
import VideoMultipleComponent from "./components/VideoMultipleComponent.vue";
import TimelineComponent from "./components/TimelineComponent.vue";
import ChronometerComponent from "./components/ChronometerComponent.vue";
import ValveInputComponent from "./components/ValveInputComponent.vue";
import ValveOutputComponent from "./components/ValveOutputComponent.vue";
import MapSelectComponent from "./components/MapSelectComponent.vue";
import PosterComponent from "./components/PosterComponent.vue";
import SelectInputComponent from "./components/SelectInputComponent.vue";
import FileOutputComponent from "./components/FileOutputComponent.vue";
import IframeOutputComponent from "./components/IframeOutputComponent.vue";

import httpMixin from "./mixins/http-mixin.js";
import httpService from "./services/http-service.js";

let IrealVue = {
  httpMixin,
  IrealViewer,
  IrealDetail,
  install(Vue, config) {
    Vue.mixin({
      components: {
        IrealViewer,
        IrealDetail,
        TextInputComponent,
        TextComponent,
        DivComponent,
        HistogramComponent,
        ButtonComponent,
        VideoComponent,
        ToggleButtonComponent,
        ProgressComponent,
        RadioButtonComponent,
        SliderInputComponent,
        MessageComponent,
        SpinnerButtonComponent,
        ModalComponent,
        MapInputComponent,
        TableInputComponent,
        TableComponent,
        CollapsibleComponent,
        GaugeInputComponent,
        GaugeComponent,
        ThreeComponent,
        InstitutionComponent,
        MapHelpHoverComponent,
        SwitchButtonComponent,
        // AirspeedComponent,
        // AltComponent,
        // AttitudeComponent,
        // HeadingComponent,
        // TurnCoordinatorComponent,
        // VariometerComponent,
        LinearInputComponent,
        SelectOutputComponent,
        CheckboxInputComponent,
        VideoMultipleComponent,
        TimelineComponent,
        ChronometerComponent,
        ValveInputComponent,
        ValveOutputComponent,
        MapSelectComponent,
        PosterComponent,
        SelectInputComponent,
        FileOutputComponent,
        IframeOutputComponent,
      },
      computed: {
        IREALCONFIG() {
          return config;
        }
      }
    });
    httpService.configure(config);
  }
};
export default IrealVue;
